import script from "./CustomerProductReturn.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerProductReturn.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerProductReturn.vue?vue&type=style&index=0&id=47e8527f&lang=scss"

const __exports__ = script;

export default __exports__